// Typelizer digest 88d8e7098902986e87609452d924af99
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /recede_historical_location */
  recede: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/recede_historical_location', {}, options),
    method: 'get',
  }),

  /** GET /resume_historical_location */
  resume: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/resume_historical_location', {}, options),
    method: 'get',
  }),

  /** GET /refresh_historical_location */
  refresh: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/refresh_historical_location', {}, options),
    method: 'get',
  }),
}
